var _path, _path2, _path3;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgKitchenOff = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.816 9H18V4H6.819L5.056 2.236C5.338 2.086 5.659 2 6 2l12 .01c1.1 0 2 .88 2 1.99v13.189l-2-2.002V10.98h-4.205L11.815 9z",
  fill: "#00163F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 6.76l-2.5-2.5 1.42-1.41L21.3 21.24l-1.41 1.41-.909-.909c-.29.165-.625.259-.981.259H6c-1.1 0-2-.9-2-2V6.76zM17.24 20L10 12.76V17H8v-5h1.24l-1.02-1.02H6V20h11.24zm-11-11H6v-.24l.24.24z",
  fill: "#00163F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 5.182l2 2.001V5H8v.182z"
})));
export default SvgKitchenOff;